import { useSelector } from 'react-redux';
import { selectPermissions } from 'store/permission/selectors';
import Cookies from 'js-cookie';

export const usePermission = () => {
    const permissions = useSelector(selectPermissions);
    const userType = Cookies.get('userType');

    const hasViewPermission = (permissionId: string): boolean => {
        if (!permissionId) return true;

        // If user is COACH, always return true for their allowed permissions
        if (userType === 'COACH' || userType === 'TEAMUSER') {
            return true;
        }

        return permissions.some(p => p.id === permissionId);
    };

    return { hasViewPermission };
};
